// Soft per-cluster tints, picked by cluster index. `bg` paints the cluster
// highlight band (light + dark), `chip` colours the cluster-id badge.
// Full literal class strings so the Tailwind scanner keeps them.
export const clusterTints = [
  { bg: 'bg-indigo-50 dark:bg-indigo-500/10', chip: 'bg-indigo-500' },
  { bg: 'bg-sky-50 dark:bg-sky-500/10', chip: 'bg-sky-500' },
  { bg: 'bg-emerald-50 dark:bg-emerald-500/10', chip: 'bg-emerald-500' },
  { bg: 'bg-amber-50 dark:bg-amber-500/10', chip: 'bg-amber-500' },
  { bg: 'bg-rose-50 dark:bg-rose-500/10', chip: 'bg-rose-500' },
  { bg: 'bg-violet-50 dark:bg-violet-500/10', chip: 'bg-violet-500' },
  { bg: 'bg-cyan-50 dark:bg-cyan-500/10', chip: 'bg-cyan-500' },
  { bg: 'bg-fuchsia-50 dark:bg-fuchsia-500/10', chip: 'bg-fuchsia-500' },
] as const;

export const clusterTint = (index: number) => clusterTints[index % clusterTints.length];
